// Centralized auth token storage.
// We use localStorage for the bearer JWT because the SPA is hosted on a
// separate origin from the backend (httpOnly cookie auth would require
// unified domain + CSRF strategy). XSS risk is mitigated by CSP headers
// at the hosting level and React's default JSX escaping. Tokens expire in 7 days.
const TOKEN_KEY = "scolaris_token";

function warnStorage(action, err) {
  // Storage may be disabled (private browsing, quota exceeded, sandboxed iframe).
  // Log to console for traceability; the app must continue without persistence.
  // eslint-disable-next-line no-console
  console.warn(`[tokenStore] localStorage ${action} failed:`, err?.message || err);
}

export const tokenStore = {
  get: () => {
    try {
      return localStorage.getItem(TOKEN_KEY);
    } catch (err) {
      warnStorage("read", err);
      return null;
    }
  },
  set: (v) => {
    try {
      localStorage.setItem(TOKEN_KEY, v);
    } catch (err) {
      warnStorage("write", err);
    }
  },
  clear: () => {
    try {
      localStorage.removeItem(TOKEN_KEY);
    } catch (err) {
      warnStorage("clear", err);
    }
  },
};
